import { useEffect } from "react";
import "./App.css";
import { useDispatch, useSelector } from "react-redux";
import Chat from "./components/Chat";
import Pusher from "pusher-js";
import Sidebar from "./components/Sidebar";
import { getMessages } from "./actions/messages";

function App() {
  const dispatch = useDispatch();
  const { messages } = useSelector((state) => state.messages);
  console.log(messages);
  useEffect(() => {
    dispatch(getMessages());
  }, [dispatch]);

  useEffect(() => {
    var pusher = new Pusher("38c482d82b9c4afa1633", {
      cluster: "ap2",
    });

    var channel = pusher.subscribe("messages");
    channel.bind("inserted", (data) => {
      messages.push(data);
    });

    return () => {
      channel.unbind_all();
      channel.unsubscribe();
    };
  }, [messages]);

  return (
    <div className="app">
      <div className="app__body">
        <Sidebar />
        <Chat messages={messages} />
      </div>
    </div>
  );
}

export default App;
